import { thunk } from 'redux-thunk';
import Signup from './signup/reducer';
import { FeatureFlagActions, FeatureFlags } from './featureFlags/types';
import { Reducer } from 'redux';
import { applyMiddleware, combineReducers, createStore, compose } from 'redux';
import {
    SignupState,
    SignupSetAction,
    SetOfficerTitles,
    SetFingerprintAction,
} from './signup/types';
import FeatureFlagging from './featureFlags/reducer';

export type AppState = {
    Signup: SignupState;
    FeatureFlagging: FeatureFlags;
};

export type AppActions =
    | SignupSetAction
    | FeatureFlagActions
    | SetOfficerTitles
    | SetFingerprintAction;

const rootReducer = combineReducers<AppState, AppActions>({
    Signup: Signup as Reducer<SignupState, AppActions>,
    FeatureFlagging: FeatureFlagging as Reducer<FeatureFlags, AppActions>,
});

const composeEnhancers =
    (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export default createStore(
    rootReducer,
    {},
    process.env.NODE_ENV === 'development'
        ? composeEnhancers(applyMiddleware(thunk))
        : applyMiddleware(thunk),
);
